module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p1-B-B-26028b0b3bde035fa7f6908a2646c0b7.png";